import React, { useState, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '../../../components/Button';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import ModalComponent from '../../../components/ModalComponent';

import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import ImgsViewer from 'react-images-viewer';

import dndIcon from './assets/dnd.svg';
import BannerEditorDialog from './modals/BannerEditorDialog';
import useStyles from './styles';

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const Banners = (props) => {
  const classes = useStyles();

  const [openModal, setOpenModal] = useState(false);
  const [openDataModal, setOpenDataModal] = useState(false);

  const [isDataSubmit, setIsDataSubmit] = useState(false);
  const [isDeleteSubmit, setIsDeleteSubmit] = useState(false);

  const [openBannerModal, setOpenBannerModal] = useState(false);
  const [isEditBanner, setIsEditBanner] = useState(false);
  const [editBannerIndex, setEditBannerIndex] = useState(null);

  const [deleteId, setDeleteId] = useState(false);
  const [deleteBanners, setDeleteBanners] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [viewPhotos, setViewPhotos] = useState([]);
  const [currentPhoto, setCurrentPhoto] = useState(0);

  const {
    images,
    setImages,
    banners,
    getImages,
    setBanners,
    onSubmit,
  } = props;
  console.log('props', props);

  const imageViewClick = (num) => {
    setCurrentPhoto(num);
    setIsOpen(true);
  };

  const handleClose = () => {
    setOpenModal(false);
    setIsDeleteSubmit(false);
  };

  const handleClickSubmit = () => {
    setOpenModal(false);
    setIsDeleteSubmit(true);
  };

  const handleDataClose = () => {
    setOpenDataModal(false);
    setIsDataSubmit(false);
  };

  const handleClickDataSubmit = () => {
    setOpenDataModal(false);
    setIsDataSubmit(true);
  };

  const handleOpenAddBanner = () => {
    setIsEditBanner(false);
    setEditBannerIndex(null);
    setOpenBannerModal(true);
  };

  const handleOpenEditBanner = (index) => {
    setIsEditBanner(true);
    setEditBannerIndex(index);
    setOpenBannerModal(true);
  };

  const handleCloseBannerModal = () => {
    setOpenBannerModal(false);
    setIsEditBanner(false);
    setEditBannerIndex(null);
  };

  const handleUpsertBanner = (bannerData) => {
    let updated = [];

    if (isEditBanner && editBannerIndex !== null) {
      updated = images.map((item, index) =>
        index === editBannerIndex
          ? {
              ...item,
              ...bannerData,
              available: !!bannerData.isAvailable,
              isAvailable: !!bannerData.isAvailable,
              order: item.order || String(index + 1),
            }
          : item
      );
    } else {
      updated = [
        ...images,
        {
          ...bannerData,
          available: !!bannerData.isAvailable,
          isAvailable: !!bannerData.isAvailable,
          order: String(images.length + 1),
        },
      ];
    }

    setImages(updated);
    setBanners(updated);
    handleCloseBannerModal();
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const data = reorder(images, result.source.index, result.destination.index);

    let newData = [];
    let imgs = [];

    for (let key in data) {
      let item = {
        ...data[key],
        dnd: true,
        order: String(+key + 1),
      };

      imgs.push({ src: item.largePhoto || item.photo || item.smallPhoto });
      newData.push(item);
    }

    setViewPhotos(imgs);
    setImages(newData);
    setBanners(newData);
  };

  const deleteBanner = (id) => {
    const nextBanners = images
      .filter((_, index) => index !== id)
      .map((banner, index) => ({
        ...banner,
        order: String(index + 1),
      }));

    setOpenModal(true);
    setDeleteBanners(nextBanners);
    setDeleteId(id);
  };

  const handleChangeAvailable = (index) => {
    const item = images[index];
    const nextStatus = !(item.isAvailable !== undefined ? item.isAvailable : item.available);

    const updated = images.map((banner, i) =>
      i === index
        ? {
            ...banner,
            isAvailable: nextStatus,
            available: nextStatus,
          }
        : banner
    );

    setImages(updated);
    setBanners(updated);
  };

  const saveClick = () => {
    let data = [];

    images.forEach((banner, index) => {
      data[index] = {
        ...banner,
        order: String(index + 1),
        available: banner.available !== undefined ? banner.available : !!banner.isAvailable,
        isAvailable: banner.isAvailable !== undefined ? banner.isAvailable : !!banner.available,
      };
    });

    onSubmit(data);
    getImages();
    setImages(data);
  };

  useEffect(() => {
    if (isDeleteSubmit) {
      let deleteImg = images.find((item, index) => index === deleteId);

      if (deleteImg && (deleteImg.photo || deleteImg.largePhoto || deleteImg.smallPhoto)) {
        let photoDeleteImg = (deleteImg.photo || deleteImg.largePhoto || deleteImg.smallPhoto).split('/');
        photoDeleteImg = photoDeleteImg[photoDeleteImg.length - 1];

        let data = {
          id: deleteId,
          data: deleteBanners,
          name: photoDeleteImg,
        };

        props.deleteBanner(data);
        setIsDeleteSubmit(false);
      } else {
        setImages(deleteBanners);
        setIsDeleteSubmit(false);
      }
    }

    if (isDataSubmit) {
      saveClick();
      setIsDataSubmit(false);
    }
  }, [isDeleteSubmit, isDataSubmit, deleteBanners, deleteId]);

  useEffect(() => {
    const filtered = banners;

    if (images.length === 0 && filtered && filtered.length > 0) {
      let photos = [];

      filtered.forEach((item) => {
        photos.push({ src: item.largePhoto || item.photo || item.smallPhoto });
      });

      setImages(filtered);
      setViewPhotos(photos);
    }
  }, [banners, images]);

  return (
    <div className={classes.banners}>
      <ModalComponent
        title="Подтвердите действие!"
        description="Хотите удалить баннер?"
        open={openModal}
        handleClose={handleClose}
        handleClickSubmit={handleClickSubmit}
      />
      <ModalComponent
        title="Подтвердите действие!"
        description="Вы подтверждаете сохранение баннеров"
        open={openDataModal}
        handleClose={handleDataClose}
        handleClickSubmit={handleClickDataSubmit}
      />

      <BannerEditorDialog
        open={openBannerModal}
        mode={isEditBanner ? 'edit' : 'add'}
        banner={isEditBanner && editBannerIndex !== null ? images[editBannerIndex] : null}
        onClose={handleCloseBannerModal}
        onSubmit={handleUpsertBanner}
      />

      <ImgsViewer
        className={classes.imgsViewer}
        imgs={viewPhotos}
        currImg={currentPhoto}
        leftArroshowCloseBtnwTitle={false}
        showImgCount={false}
        preventAutoScroll={false}
        enableKeyboardInput={false}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />

      <div className={classes.bannersContent}>
        <Typography variant="h6" component="h2" className={classes.warningMessage}>
          Используйте модалку баннера для настройки: название, описание, активность, большая и маленькая картинки.
        </Typography>
        {images.length === 0 && <div className={classes.noBanners}>Пока нет баннеров</div>}

        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <div {...provided.droppableProps} ref={provided.innerRef}>
                {images.map((item, index) => {
                  const isBannerAvailable = item.isAvailable !== undefined ? item.isAvailable : item.available;
                  const bannerImage = item.data_url || item.largePhoto || item.photo || item.smallPhoto;

                  return (
                    <Draggable key={index} draggableId={String(index)} index={index}>
                      {(providedDraggable) => (
                        <div
                          key={index}
                          className={classes.bannerWrap}
                          ref={providedDraggable.innerRef}
                          {...providedDraggable.draggableProps}
                          {...providedDraggable.dragHandleProps}
                        >
                          <div className={classes.banner}>
                            <div className={classes.bannerContentWrap}>
                              <div className={classes.imageWrap}>
                                <div
                                  style={{ backgroundImage: `url(${bannerImage})` }}
                                  className={classes.image}
                                  onClick={() => imageViewClick(index)}
                                />
                              </div>
                              <div style={{ marginLeft: 12 }}>
                                <div style={{ fontWeight: 600, color: '#243447' }}>{item.title || 'Без названия'}</div>
                                <div style={{ color: '#6b7c93', fontSize: 13 }}>{item.description || 'Без описания'}</div>
                              </div>
                            </div>

                            <div className={classes.controlWrap}>
                              <div className={classes.trash} onClick={() => handleChangeAvailable(index)}>
                                {isBannerAvailable ? <VisibilityIcon className={classes.trashIcon} /> : <VisibilityOffIcon className={classes.trashIcon} />}
                              </div>
                              <div className={classes.trash} onClick={() => handleOpenEditBanner(index)}>
                                <EditIcon className={classes.trashIcon} />
                              </div>
                              <div className={classes.trash} onClick={() => deleteBanner(index)}>
                                <DeleteOutlineIcon className={classes.trashIcon} />
                              </div>
                            </div>
                          </div>
                          <div className={classes.dnd}>
                            <img src={dndIcon} alt="dnd" />
                          </div>
                        </div>
                      )}
                    </Draggable>
                  );
                })}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </div>

      <div className={classes.buttonsWrap}>
        <div className={classes.buttons}>
          <Button className={classes.addBanner} handleClick={handleOpenAddBanner} load={false} text="Добавить баннер" />
          <Button className={classes.saveBanner} load={false} text="Сохранить" handleClick={() => setOpenDataModal(true)} />
        </div>
      </div>
    </div>
  );
};

export default Banners;
